/* Solli's Shop-Bewertung: holt Durchschnitt und Anzahl der Shop-Bewertungen von Reviews.io (oeffentliche Schnittstelle
   stats/all, nur der Store-Schluessel noetig) und setzt sie in alle Stellen mit data-sollis-bewertung ein.
   Zwischenspeicher 12 Stunden je Besucher. Antwortet Reviews.io nicht, bleibt der Rueckfallwert aus dem HTML stehen.
   Ausgegeben ueber snippets/sollis-bewertung.liquid. */
(function () {
  if (window.sollisBewertung) { window.sollisBewertung.anwenden(); return; }
  var KEY = 'sollis_bewertung', TTL = 12 * 36e5;
  var skript = document.currentScript;
  var store = (skript && skript.getAttribute('data-store')) || 'sollis-hundebedarf.de';
  var werte = null;
  function lies() {
    try {
      var w = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (w && w.s === store && w.n > 0 && w.r > 0 && w.r <= 5) return w;
    } catch (e) {}
    return null;
  }
  function anwenden() {
    if (!werte) return;
    var l = document.documentElement.getAttribute('lang') || 'de', fs = null, fa = null;
    try {
      fs = new Intl.NumberFormat(l, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      fa = new Intl.NumberFormat(l, { maximumFractionDigits: 0 });
    } catch (e) {}
    var schnitt = Math.round(werte.r * 10) / 10;
    var els = document.querySelectorAll('[data-sollis-bewertung]');
    for (var i = 0; i < els.length; i++) {
      var art = els[i].getAttribute('data-sollis-bewertung');
      if (art === 'schnitt') els[i].textContent = fs ? fs.format(schnitt) : schnitt.toFixed(1).replace('.', ',');
      else if (art === 'anzahl') els[i].textContent = fa ? fa.format(werte.n) : String(werte.n);
    }
  }
  function holen() {
    if (typeof fetch !== 'function') return;
    try {
      fetch('https://api.reviews.io/stats/all?store=' + encodeURIComponent(store))
        .then(function (r) { if (!r.ok) throw new Error('Reviews.io ' + r.status); return r.json(); })
        .then(function (j) {
          var c = j && j.company_review_stats;
          var r = c ? parseFloat(c.average_rating) : NaN, n = c ? parseInt(c.total_reviews, 10) : NaN;
          if (!(r > 0 && r <= 5 && n > 0)) return;
          werte = { s: store, r: r, n: n, t: Date.now() };
          try { localStorage.setItem(KEY, JSON.stringify(werte)); } catch (e) {}
          anwenden();
        })
        .catch(function () {});
    } catch (e) {}
  }
  werte = lies();
  window.sollisBewertung = { anwenden: anwenden };
  if (werte) anwenden();
  if (!werte || Date.now() - werte.t > TTL) holen();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', anwenden);
  document.addEventListener('shopify:section:load', anwenden);
})();
